import { render, staticRenderFns } from "./Ingress.vue?vue&type=template&id=46d24d2c&"
import script from "./Ingress.vue?vue&type=script&lang=js&"
export * from "./Ingress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports